

import { Component, Mixins } from 'vue-property-decorator';
import PopupMixin from '~common-mixins/PopupMixin';
import { DevicesModule } from '~/store/modules/devices';
import DumpPopupMixin from '~/mixins/dumpPopup.mixin';

@Component
export default class OperationDumpPopup extends Mixins(PopupMixin, DumpPopupMixin) {
    filePrefix = 'Dump';

    get rawDumpValue() {
        return DevicesModule.dumpValue;
    }

    async getDump() {
        try {
            const data = await DevicesModule.currentGateway?.dump();
            await DevicesModule.setDumpValue(data);
        } catch (error) {
            await DevicesModule.setDumpValue('Error while fetching dump');
        }
    }
}
